import React from 'react';
import { Link } from 'react-router-dom'
import cruz from '../../../../imagenes/paquetes/ribbon/cruz.png'
import get from '../../../../utils/get';
import { calcularPrecioCharter } from '../../../../utils/Tools';

const Precio = (props) => {
  const { producto, onClickComprar, charterSeleccionado, totalesDeHabitaciones, tarifaPorHabitacion } = props;
  const precioOriginal = tarifaPorHabitacion ? totalesDeHabitaciones.totalNetoPorPersonaAntesDeValijaYa :  Math.round(charterSeleccionado ? charterSeleccionado.tarifa.tarifaNeta : producto.charters[0].tarifa.tarifaNeta).toLocaleString();
  const precioDescontado = tarifaPorHabitacion ? totalesDeHabitaciones.totalPorPersonaConValijaYaNeto : calcularPrecioCharter(charterSeleccionado ? charterSeleccionado : producto.charters[0]);// Math.round((((producto.charters[0].tarifa.tarifaNeta - (producto.charters[0].tarifa.tarifaNeta * (producto.charters[0].promoValijaYa / 100)))) + producto.charters[0].tarifa.adicionalPorDia)).toLocaleString();
  const precioCharteSeleccionado = tarifaPorHabitacion ? totalesDeHabitaciones.totalPorPersonaConValijaYaNeto : calcularPrecioCharter(charterSeleccionado);
  /*
  let precio = Math.round(producto.tarifas[0].tarifaNeta * producto.moneda.cotizacion).toLocaleString();
  if (producto.charters.length > 0)
      precio = Math.round((((producto.charters[0].tarifa.tarifaNeta - (producto.charters[0].tarifa.tarifaNeta * (producto.charters[0].promoValijaYa / 100)))) + producto.charters[0].tarifa.adicionalPorDia) * producto.moneda.cotizacion).toLocaleString();
*/
  //const url = get(window, 'location.href', '');
  //const claseParaPrecio = url.includes('NAVIDAD') ? 'price navidad' : url.includes('NUEVO') ? 'price anio-nuevo' : 'price';

  return (
        <div className={`price col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12`}>
          <h6>Precio por persona</h6>
          {/*producto.moneda.codigoMoneda !== 'PES' && <h6>{producto.tarifas[0].tarifaNeta} {producto.moneda.codigoMoneda} (T. Cambio 1 {producto.moneda.codigoMoneda} = $ {producto.moneda.cotizacion.substr(0,5)})</h6> */}
          {
            ((precioCharteSeleccionado && precioCharteSeleccionado < precioOriginal) || precioDescontado < precioOriginal) &&
            <div className='divPrecioAntes'>
              <img src={cruz} alt="Etiqueta Precio Antes" height="60px"/>
              <span>Antes</span>
              <h4>{producto.moneda.simbolo} { precioOriginal.toLocaleString()}</h4>
              <p style={{margin: '0', color: '#fff'}}>+ Tasas e Impuestos</p>
              <span>Ahora</span>
            </div>
          }
          
          {tarifaPorHabitacion ? (
            <h3>{producto.moneda.simbolo} {Math.trunc(get(totalesDeHabitaciones, 'totalPorPersonaConValijaYaNeto', '')).toLocaleString()}</h3>
          ) : (
            <h3>{producto.moneda.simbolo} { precioCharteSeleccionado || precioDescontado || precioOriginal}</h3>
          )}
         
          <p style={{margin: '0', color: '#fff'}}>+ Tasas e Impuestos</p>
          {tarifaPorHabitacion && <p style={{color: '#fff'}}>{totalesDeHabitaciones.textoBase}</p>}
          {!tarifaPorHabitacion && (<Link to={`/paquete-turistico/proceso-compra/login`} onClick={onClickComprar}><button>comprar</button></Link>)}
          {/* <h6>Pag&aacute; en cuotas</h6> */}
        </div>
        )
}

export default Precio



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/Precio.js